<template>
  <div class="SX">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoPartyDiscipline">党纪法规></span>
        <span @click="GoFenLei">分类系统></span>
        <span class="red">正文</span>
      </div>
      <!-- 正文 -->
      <div class="zhengwen">
        <h1>党委（党组）落实全面从严治党主体责任规定</h1>
        <div class="first">
          <p>党委（党组）落实全面从严治党主体责任规定</p>
          <p>（2020年2月26日中共中央政治局常委会会议审议批准 2020年3月9日中共中央办公厅发布）</p>
        </div>
        <div class="date">发布时间：2020-5-20&nbsp13:30</div>
        <div class="xh"></div>

        <div class="second">
          <strong>
            <p>第一章 总则</p>
          </strong>
          <p>第一条 为了全面落实党委（党组）全面从严治党主体责任，推动全面从严治党向纵深发展，根据《中国共产党章程》和有关党内法规，制定本规定。</p>

          <p>第二条 本规定适用于地方党委和按照《中国共产党党组工作条例》设立的党组（党委）。</p>

          <p>党的纪律检查机关、党的工作机关、党委直属事业单位在本单位落实全面从严治党主体责任，党的基层组织落实全面从严治党主体责任，参照本规定执行。</p>

          <p>第三条 党委（党组）必须深入贯彻习近平新时代中国特色社会主义思想，增强“四个意识”、坚定“四个自信”、做到“两个维护”，不忘初心、牢记使命，守责、负责、尽责，一以贯之、坚定不移全面从严治党，以伟大自我革命引领伟大社会革命，以科学理论引领全党理想信念，以“两个维护”引领全党团结统一，以正风肃纪反腐凝聚党心军心民心，永葆党的先进性和纯洁性，确保党始终成为中国特色社会主义事业的坚强领导核心。</p>
          <p>第四条 党委（党组）落实全面从严治党主体责任，应当遵循以下原则：</p>
          <p>（一）坚持紧紧围绕加强和改善党的全面领导；</p>
          <p>（二）坚持全面从严治党各领域各方面各环节全覆盖；</p>
          <p>（三）坚持真管真严、敢管敢严、长管长严；</p>
          <p>（四）坚持全面从严治党过程和效果相统一。</p>
          <p>第五条 中央和国家机关在全面从严治党中具有特殊地位和作用，必须在落实全面从严治党责任中走在前、作表率，全面提高机关党的建设质量，建设让党中央放心、让人民群众满意的模范机关，引领带动各地区各部门抓好全面从严治党。</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    GoPartyDiscipline() {
      this.$router.push("/PartyDiscipline");
    },
    GoFenLei() {
      this.$router.push("/PartyDiscipline/FenLei");
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
.zhengwen {
  width: 1200px;
  background-color: white;
  padding: 60px;
  box-sizing: border-box;
}
p {
  text-indent: 2em;
  font-size: 16px;
  color: #333333;
  margin-top: 20px;
}

h1 {
  text-align: center;
  font-size: 28px;
  color: #333333;
}
.first {
  text-align: center;
  font-size: 16px;
  color: #999999;
  margin-top: 28px;
  margin-bottom: 30px;
}
.daohang {
  margin: 20px 0;
}
.first p {
  font-weight: 600;
}
.date{
  color: #999999;
  font-size: 16px;
  text-align: center;
  margin-bottom: 28px;
}
</style>